export default {"src":"/_next/static/media/copy-link-icon.8f301921.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};